export default __webpack_public_path__ + "static/media/PaperAirplane.bd7e2029.jpeg";